import { render } from "./EditQuotaTariff.vue?vue&type=template&id=604233fe&scoped=true"
import script from "./EditQuotaTariff.vue?vue&type=script&lang=js"
export * from "./EditQuotaTariff.vue?vue&type=script&lang=js"

import "./EditQuotaTariff.vue?vue&type=style&index=0&id=604233fe&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604233fe"]])

export default __exports__